// disable useContraMutation eslint error

import { type useAddUserInterfaceFlagMutation } from '#app/__generated__/relay/useAddUserInterfaceFlagMutation.graphql.js';
import { graphql, useMutation } from '@contra/relay';

export const useAddUserInterfaceFlag = () => {
  const mutation = useMutation<useAddUserInterfaceFlagMutation>(graphql`
    mutation useAddUserInterfaceFlagMutation(
      $input: AddUserInterfaceFlagInput!
    ) {
      addUserInterfaceFlag(input: $input) {
        errors {
          message
        }

        userAccount {
          userInterfaceFlags
          ...CurrentUser
        }
      }
    }
  `);

  return mutation;
};
